import { NavLink } from "react-router-dom";

const NavTabs = ({ listOfTabs }) => {
  return (
    <ul className="nav nav-tabs">
      {listOfTabs.map((tab) => (
        <li key={tab.key} className="nav-item">
          <NavLink
            to={tab.to}
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
          >
            {tab.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

export default NavTabs;
